export const defaultEditorConfig = {
    "config": { //neaplikovano ve vue
        type: [Object],
        required: false,
        default: {
            attributes: {
                element_id_name: 'data-cms-element-id',
                element_typ_name: 'data-cms-element-type',
                element_values_name: 'data-cms-element-form-inputs',
            },
            action: {
                create: 'create',
                edit: 'edit',
                delete: 'delete',
            },
            timerObj: {
                mounted: null,
                renderDelay: null,
                onMounted: null,
                onClickLoadAttr: null,
                codeType: null,
                clearCode: null,
            },
            timer: {
                renderDelay: 10,
                onMounted: 5,
                onClickLoadAttr: 1,
                codeType: 500,
                clearCode: 750,
            }
        }
    },
    "buttonsDefinition": {
        type: [Object],
        required: false,
        default: {
            p: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.p.title',
                ico: {
                    class: 'bi bi-justify-left'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'p',
                params: {
                    style: {
                        //value: 'text-align: left;',
                        readonly: false,
                        default: null,
                    },
                },
            },

            a: {
                title: 'wysiwyg.action.link.title' , //+ this.$t('wysiwyg.action.link.title')
                innerHtmlPlaceholder: true,
                ico: {
                    class: 'bi bi-link'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'a',
                params: {
                    href: {
                        value: null,
                        readonly: false,
                        default: null,
                    },
                    class: {
                        value: null,
                        readonly: false,
                        default: null,
                    },
                    target: {
                        value: null,
                        readonly: false,
                        default: '_self',
                    },
                },
                dialog: {
                    title: 'wysiwyg.action.link.dialog.title',
                    //btn_footer: true,
                    btn_footer:{
                        submit:{
                            title: 'wysiwyg.action.link.dialog.submit.title',
                            class: 'btn btn-primary',
                            ico: {
                                class: 'bi bi-check'
                            },

                        }
                    },
                    inputs: {
                        href: {
                            title: 'wysiwyg.action.link.dialog.url.title',
                            type: 'text', // select, boolean, checkbox
                            isMandatory: true,
                            isRender: true,
                            //todo naplneni selectu1
                        },
                        target: {
                            title: 'wysiwyg.action.link.dialog.window.title',
                            type: 'select', // select, boolean, checkbox
                            isMandatory: true,
                            isRender: true,
                            defaultValue: '_blank',
                            select: {
                                '_self': {
                                    'title': 'wysiwyg.action.link.dialog.window.select.self'
                                },
                                '_blank': {
                                    'title': 'wysiwyg.action.link.dialog.window.select.blank'
                                },
                            }
                        },
                        note: {
                            title: 'wysiwyg.action.link.dialog.note.title',
                            type: 'text', // select, boolean, checkbox
                            isMandatory: false,
                            isRender: false,
                            //todo naplneni selectu1
                        },
                    },
                },
                help: 'wysiwyg.action.link.help',

            },
            strong: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.bold.title',
                ico: {
                    class: 'bi bi-type-bold'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'strong',
                params: {
                    /*
                    href: {
                      value: null,
                      readonly: false,
                      default: null,
                      isRender: false,
                    },
                    */
                    class: {
                        value: 'testovaci-trida',
                        readonly: false,
                        isRender: true,
                    },
                },
                help: 'wysiwyg.action.bold.help',
            },
            italic: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.italic.title',
                ico: {
                    class: 'bi bi-type-italic'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'i',
            },
            underline: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.underline.title',
                ico: {
                    class: 'bi bi-type-underline'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'u',
            },
            sup: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.sup.title',
                ico: {
                    class: 'bi bi-superscript'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'sup',
            },
            sub: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.sub.title',
                ico: {
                    class: 'bi bi-subscript'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'sub',
            },

            table: {
                title: 'wysiwyg.action.table.title',
                ico: {
                    class: 'bi bi-table'
                },
                isActive: false,
                isDisabled: false,
                isWrap: false,
                tagName: 'table',
                /*
                editAction: {
                    "addCol": {
                        title: 'wysiwyg.action.table.action.addCollumn',
                        ico: {
                            class: 'bi bi-box-arrow-right'
                        },
                        onClick: 'tableAddRowCol'
                    },
                    "addRow": {
                        title: 'wysiwyg.action.table.action.addRow',
                        ico: {
                            class: 'bi bi-box-arrow-in-down'
                        },
                        onClick: 'tableAddRow'
                    },
                },
                */
                child: [
                    {
                        tagName: 'tr',
                        params: {
                            class: 'tr-zero'
                        },
                        child: [
                            {
                                tagName: 'td',
                                params: {
                                    class: 'td-first'
                                },
                                content: '&nbsp;',
                                innerHtmlPlaceholder: false,
                            },
                            {
                                tagName: 'td',
                                params: {
                                    class: 'td-secod'
                                },
                                content: '&nbsp;',
                            },
                            {
                                tagName: 'td',
                                params: {
                                    class: 'td-tri'
                                },
                                content: '&nbsp;',
                            }
                        ]
                    },
                    {
                        tagName: 'tr',
                        //content: 'obsah druheho',
                        params: {
                            class: 'first-li-second'
                        },
                        child: [
                            {
                                tagName: 'td',
                                params: {
                                    class: 'td-first'
                                },
                                content: '&nbsp;',

                            },
                            {
                                tagName: 'td',
                                params: {
                                    class: 'td-secod'
                                },
                                content: '&nbsp;',
                            },
                            {
                                tagName: 'td',
                                params: {
                                    class: 'td-tri'
                                },
                                content: '&nbsp;',
                            }
                        ]
                    },
                ],
                params: {
                    'class': 'table table-responsive'
                },
                help: 'wysiwyg.action.table.help',
            },
            ul: {
                title: 'wysiwyg.action.ul.title',
                ico: {
                    class: 'bi bi-list-ul'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'ul',
                child: [
                    {
                        tagName: 'li',
                        innerHtmlPlaceholder: true,
                        //_content: 'obsah',
                        params: {
                            class: 'first-li-filled'
                        },
                    },
                    {
                        tagName: 'li',
                        //content: 'obsah druheho',
                        params: {
                            class: 'first-li-second'
                        },
                    },
                ],
                params: {
                },
                help: 'wysiwyg.action.ul.help',
            },
            ol: {
                title: 'wysiwyg.action.ol.title',
                ico: {
                    class: 'bi bi-list-ol'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'ol',
                child: [
                    {
                        tagName: 'li',
                        innerHtmlPlaceholder: true,
                        //_content: 'obsah',
                        params: {
                            class: 'first-li-filled'
                        },
                    },
                    {
                        tagName: 'li',
                        //content: '&nbsp;',
                        params: {
                            class: 'first-li-second'
                        },
                    },
                ],
                params: {
                },
                help: 'wysiwyg.action.ol.help',
            },
            hr: {
                title: 'wysiwyg.action.hr.title',
                ico: {
                    class: 'bi bi-dash'
                },
                isActive: false,
                isDisabled: false,
                isWrap: false,
                tagName: 'hr',
                params: {
                    x: {
                        value: null,
                        readonly: false,
                        default: null,
                    }
                },
            },
            div: {
                innerHtmlPlaceholder: true,
                title: 'wysiwyg.action.div.title',
                ico: {
                    class: 'bi bi-card-text'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                tagName: 'div',
                params: {
                    class: {
                        value: 'cms-div',
                        readonly: false,
                        default: null,
                    },
                },
            },
            mention: {
                tagName: 'a',
                title: 'wysiwyg.action.mention.title',
                innerHtmlPlaceholder: true,
                ico: {
                    class: 'bi bi-person-raised-hand'
                },
                isActive: false,
                isDisabled: false,
                isWrap: true,
                help: 'wysiwyg.action.mention.help',
                dialog: {
                    title: 'Zminka',
                    config: {
                        methods: {
                            paths: {
                                display: {
                                    //path: '/class/content/dev-wysiwig-editor-dialog',
                                    path: '/class/topic/list-search',
                                    method: 'post'
                                },
                                generate: {
                                    //path: '/class/content/wysiwig-editor-artist',
                                    path: '/class/topic/insert-topic-link',
                                    method: 'post'
                                },
                            },
                        },
                    },
                    btn_footer: false,
                    type: 'dynamic', // static | dynamic | null
                }
            },

            ai_text: {
                tagName: null,
                title: 'wysiwyg.action.ai_text.title',
                innerHtmlPlaceholder: true,
                ico: {
                    class: 'bi bi-openai'
                },
                isActive: false,
                isDisabled: false,
                isWrap: false,
                isTextOnly: true,
                help: 'wysiwyg.action.ai_text.help',
                dialog: {
                    title: 'Ai generovay text',
                    config: {
                        methods: {
                            paths: {
                                display: {
                                    //path: '/class/content/dev-wysiwig-editor-dialog',
                                    path: '/class/content/ai-text-form',
                                    method: 'post'
                                },
                                generate: {
                                    path: '/class/content/ai-text-generate',
                                    method: 'post'
                                },
                            },
                        },
                    },
                    btn_footer: false,
                    type: 'dynamic', // static | dynamic | null
                }
            },


        }
    },
    "specialsDefinition": {
        type: [Object],
        required: false,
        default: {
            clearFormatComplete: {
                title: 'wysiwyg.action.clear_format_complete.title',
                ico: {
                    class: 'bi bi-eraser'
                },
                onClick: 'clearFormatComplete'
            },
            removeElement: {
                title: 'wysiwyg.action.remove_format_element.title',
                displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-x'
                },
                onClick: 'removeElementOther'
            },
            cleanCode: {
                title: 'wysiwyg.action.clean_code.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-eraser'
                },
                onClick: 'optimazeHtml'
            },
            fullscreenToggleOn: {
                title: 'wysiwyg.action.fullscreen_toggle_on.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-fullscreen'
                },
                onClick: 'toggleFullscreen'
            },
            fullscreenToggleOff: {
                title: 'wysiwyg.action.fullscreen_toggle_off.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-fullscreen-exit'
                },
                onClick: 'toggleFullscreen'
            },
            search: {
                title: 'wysiwyg.action.search.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-search'
                },
                //special: true,
                //type: 'search',
                elements: [
                    {
                        element: 'input',
                        vModelName: 'searchAttr'
                    }
                ],
                onClick: 'switchSearchDisplay',
                help: 'wysiwyg.action.search.help'
            },
            switchEditorToCode: {
                title: 'wysiwyg.action.switch_editor_to_code.title',
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-code'
                },
                onClick: 'switchEditor'
            },
            help: {
                title: '', //Help
                //displayMethod: 'isRemoveElement',
                ico: {
                    class: 'bi bi-question-circle'
                },
                onClick: 'switchHelp'
            },

        }
    }
};